import {
  LIBRARY_SALES_TYPE_PAGE_REQUEST,
  LIBRARY_SALES_TYPE_ON_CLICK_ROW,
  LIBRARY_SALES_TYPE_ON_CLICK_CANCEL,
  LIBRARY_SALES_TYPE_DELETE_SALES_REQUEST,
  LIBRARY_SALES_TYPE_DELETE_SALES,
  LIBRARY_SALES_TYPE_CANCEL_DELETE,
  LIBRARY_SALES_TYPE_ACTIVATED_SALES_REQUEST,
  LIBRARY_SALES_TYPE_ACTIVATED_SALES,
  LIBRARY_SALES_TYPE_CANCEL_ACTIVATED,
  LIBRARY_SALES_TYPE_ON_CHANGE_OUTLET_IDS,
  LIBRARY_SALES_TYPE_ON_CLICK_CREATE_SALES,
  LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE,
  LIBRARY_SALES_TYPE_SUBMIT_FORM_UPDATE,
  LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE_ALL_OUTLETS,
  LIBRARY_SALES_TYPE_LIST_REQUEST,
  LIBRARY_SALES_TYPE_RESERVED_FIND_BY_NAME,
} from 'actions/library/salesType/constants';
import { takeLatest, put, call, takeEvery, select } from 'redux-saga/effects';
import { initialize, change } from 'redux-form';
import * as act from 'actions';
import * as actNotif from 'actions/notifications';
import * as actSalesType from 'actions/library/salesType';
import * as apiOutlets from 'api/outlets';
import * as apiProfile from 'api/profile';
import * as apiGratuity from 'api/gratuities';
import * as apiSalesType from 'api/libraries/salesType';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import { setSelectedOutletIds } from 'actions/actionBar';
import * as clevertapLibrarySalesType from 'clevertap/library/salesType';
import * as actOutletList from 'actions/outletPages/list';

const getCloneNotification = state =>
  state.outletPages.list.showCloneOutletNotification.notification;

function* getCloneOutletNotification() {
  const notification = yield select(getCloneNotification);
  return notification;
}

function* fillSearchFormFromProfile(profile) {
  let assignedOutletIds = [];
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]];
  } else {
    assignedOutletIds = profile.outlet_id;
  }
  const data = { outletIds: assignedOutletIds };
  yield put(initialize('search', data));
}

function* closeRightColumn() {
  yield put(actSalesType.closeRightColumn());
}

export function* salesTypePageRequestFlow() {
  // reset
  yield put(actSalesType.setListSalesType([]));
  yield put(showPageLoadingSpinner(true));
  yield put(actSalesType.setSalesTypeDetail(null));
  yield put(actSalesType.setOutlets([]));
  yield call(closeRightColumn);

  yield put(act.showProgressBar());
  try {
    const response = yield call(apiOutlets.outlets);
    yield put(actSalesType.setOutlets(response.data));
    const resProfile = yield call(apiProfile.getProfile);
    yield call(fillSearchFormFromProfile, resProfile.data);
    yield put(
      actSalesType.setGratuityStatusFromSetting(
        resProfile.data.business.setting.enable_gratuity
      )
    );
    const params = {
      page: 0,
      keyword: '',
      outletId: resProfile.data.outlet_id[0],
      size: 50,
      isAdvanceOrdering: true,
    };
    const resSalesType = yield call(apiSalesType.getSalesType, params);
    const sales = resSalesType.data.content;
    yield put(actSalesType.setListSalesType(sales));
    yield put(actSalesType.setTotalPage(resSalesType.data.total_pages));
    yield put(actSalesType.setCurrentPage(resSalesType.data.number));
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* salesTypeRequestFlow(action) {
  const {
    payload: { params, previousSales },
  } = action;
  yield put(act.showProgressBar());
  try {
    const response = yield call(apiSalesType.getSalesType, params);
    const sales = previousSales.concat(response.data.content);
    yield put(actSalesType.setListSalesType(sales));
    yield put(actSalesType.setTotalPage(response.data.total_pages));
    yield put(actSalesType.setCurrentPage(response.data.number));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

function* openRightColumn() {
  yield put(actSalesType.openRightColumn());
}

export function* onClickRowFlow(request) {
  const {
    payload: { salesType },
  } = request;
  try {
    yield put(act.showProgressBar());
    const resGratuity = yield call(apiGratuity.getGratuities, { page: 1 });
    yield put(actSalesType.setGratuity(resGratuity.data));
    const resSalesTypeDetail = yield call(
      apiSalesType.getSalesTypeDetail,
      salesType.id
    );
    const salesTypeDetail = resSalesTypeDetail.data;
    const tempIdGratuities = [];
    salesTypeDetail.gratuities.forEach(gratuiti => {
      tempIdGratuities.push(gratuiti.id);
    });
    const currentSalesType = {
      active_gratuities: tempIdGratuities,
      active_state: salesTypeDetail.active_state,
      business_id: salesTypeDetail.business_id,
      gratuity_applied_count: salesTypeDetail.gratuity_applied_count,
      id: salesTypeDetail.id,
      name: salesTypeDetail.name,
      outlet_id: salesTypeDetail.outlet_id,
      synchronized_at: salesTypeDetail.synchronized_at,
      updated_at: salesTypeDetail.updated_at,
      is_advance_ordering: salesTypeDetail.is_advance_ordering,
      has_business_level_entity: salesTypeDetail.has_business_level_entity,
    };
    yield put(actSalesType.setSalesTypeDetail(currentSalesType));
    yield call(fillFormSalesTypeDetail, currentSalesType);
    yield put(actSalesType.setMustScrollTop(true));
    yield call(openRightColumn);
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actSalesType.setMustScrollTop(false));
  }
}

function* fillFormSalesTypeDetail(salesTypeDetail) {
  const formSalesTypeDetail = {
    id: salesTypeDetail.id,
    name: salesTypeDetail.name,
    gratuity_applied_count: salesTypeDetail.gratuity_applied_count,
    outlet_id: salesTypeDetail.outlet_id,
    active_gratuities: salesTypeDetail.active_gratuities,
    has_business_level_entity: salesTypeDetail.has_business_level_entity,
  };

  yield put(initialize('salesType', formSalesTypeDetail));
}

export function* onClickCancelFlow() {
  yield put(actSalesType.setSalesTypeDetail(null));
  yield call(fillFormSalesTypeDetail, [
    {
      id: null,
      name: null,
      gratuity_applied_count: null,
      active_gratuity: [],
      status: true,
    },
  ]);
  yield call(closeRightColumn);
}

// deleted
export function* deleteSalesTypeRequest(request) {
  const {
    payload: { deletedSalesType },
  } = request;
  const isDeletableResponse = yield call(
    apiSalesType.checkSalesTypeDeletable,
    deletedSalesType.id
  );
  const isDeletable = isDeletableResponse.data;
  if (isDeletable) {
    yield put(actSalesType.setDeletedSalesType(deletedSalesType));
    yield put(actSalesType.showDeleteModal());
  } else {
    yield put(
      actSalesType.showSalesTypeDeletableModal(
        deletedSalesType.id,
        true,
        'Delete'
      )
    );
  }
}

// noinspection JSAnnotator
export function* deleteSalesTypeFlow(request) {
  const {
    payload: { currentOutletId, id, previousSales },
  } = request;
  yield put(act.showProgressBar());
  yield put(actSalesType.isSubmittingForm(true));
  try {
    yield call(apiSalesType.deleteSalesType, id);
    const salesTypeNew = [];
    previousSales.forEach(salesType => {
      if (salesType.id !== id) {
        salesTypeNew.push(salesType);
      } else {
        clevertapLibrarySalesType.salesTypeDelete({
          salesTypeName: salesType.name,
          outletIds: currentOutletId.outletIds,
        });
      }
    });
    yield put(actSalesType.setSalesTypeDetail(null));
    yield put(actSalesType.setDeletedSalesType(null));
    yield put(actSalesType.hideDeleteModal());
    yield call(closeRightColumn);
    yield put(
      actNotif.success(
        'Sales Type was successfully removed.',
        yield getCloneOutletNotification()
      )
    );
    yield call(salesTypePageRequestFlow);
    yield put(actSalesType.isSubmittingForm(false));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* cancelDeleteSalesTypeFlow() {
  yield put(actSalesType.setDeletedSalesType(null));
  yield put(actSalesType.hideDeleteModal());
}

// activated
export function* activatedSalesTypeRequest(request) {
  const {
    payload: { activatedSalesType },
  } = request;
  if (activatedSalesType.active_state === true) {
    const isDeactivableResponse = yield call(
      apiSalesType.checkSalesTypeDeletable,
      activatedSalesType.id
    );
    const isDeactivable = isDeactivableResponse.data;
    if (isDeactivable === false) {
      yield put(
        actSalesType.showSalesTypeDeletableModal(
          activatedSalesType.id,
          true,
          'Deactive'
        )
      );
    } else {
      yield put(actSalesType.setActivatedSalesType(activatedSalesType));
      yield put(actSalesType.showActivatedModal());
    }
  } else {
    yield put(actSalesType.setActivatedSalesType(activatedSalesType));
    yield put(actSalesType.showActivatedModal());
  }
}

export function* activatedSalesTypeFlow(request) {
  const {
    payload: { currentOutletId, salesTypeDetail, previousSalesType },
  } = request;
  yield put(act.showProgressBar());

  try {
    yield call(apiSalesType.activatedSalesType, salesTypeDetail.id, {
      active_state: !salesTypeDetail.active_state,
    });
    let salesTypeActivated = {};
    previousSalesType.forEach(salesActivated => {
      if (salesActivated.id === salesTypeDetail.id) {
        salesTypeActivated = salesActivated;
      }
    });
    yield put(actSalesType.salesTypePageRequest());
    yield put(actSalesType.setSalesTypeDetail(null));
    yield put(actSalesType.setActivatedSalesType(null));
    yield put(actSalesType.hideActivatedModal());
    if (!salesTypeActivated.active_state) {
      yield put(
        actNotif.success(
          `${salesTypeActivated.name} was successfully Reactivated.`,
          yield getCloneOutletNotification()
        )
      );
      clevertapLibrarySalesType.salesTypeReactivate({
        salesTypeName: salesTypeDetail.name,
        outletIds: currentOutletId.outletIds,
      });
    } else {
      yield put(
        actNotif.success(
          `${salesTypeActivated.name} was successfully Deactivated.`,
          yield getCloneOutletNotification()
        )
      );
      clevertapLibrarySalesType.salesTypeDeactivate({
        salesTypeName: salesTypeDetail.name,
        outletIds: currentOutletId.outletIds,
      });
    }
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* cancelActivatedSalesTypeFlow() {
  yield put(actSalesType.setActivatedSalesType(null));
  yield put(actSalesType.hideActivatedModal());
}

// outlets change
export function* onChangeOutletIds(action) {
  yield put(actSalesType.setListSalesType([]));
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { outletIds },
  } = action;

  try {
    yield put(actSalesType.setSalesTypeDetail(null));
    yield call(closeRightColumn);
    yield call(fillFormSalesTypeDetail, {
      id: null,
      name: null,
      gratuity_applied_count: null,
      outlet_id: null,
      active_gratuities: [],
    });
    yield put(act.showProgressBar());
    yield call(apiOutlets.patchLogin, { id: outletIds });
    const params = {
      page: 0,
      keyword: '',
      outletId: outletIds[0],
      size: 50,
      isAdvanceOrdering: true,
    };
    yield put(setSelectedOutletIds(outletIds));
    yield put(change('search', 'outletIds', outletIds));
    const res = yield call(apiSalesType.getSalesType, params);
    yield put(actSalesType.setListSalesType(res.data.content));
    yield put(actSalesType.setTotalPage(res.data.total_pages));
    yield put(actSalesType.setCurrentPage(res.data.number));
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* findSalesTypeReservedByNameFlow(request) {
  const {
    payload: { salesTypeName },
  } = request;
  const resSalesTypeReserved = yield call(
    apiSalesType.findSalesTypeReserved,
    salesTypeName
  );
  yield put(actSalesType.setSalesTypeReserved(resSalesTypeReserved.data));
}

// save
export function* onClickCreateSalesTypeFlow() {
  yield put(actSalesType.setSalesTypeDetail(null));
  yield put(actSalesType.setSalesTypeReserved(null));
  yield call(fillFormSalesTypeDetail, {
    id: null,
    name: null,
    gratuity_applied_count: null,
    outlet_id: null,
    active_gratuities: [],
  });
  const resGratuity = yield call(apiGratuity.getGratuities, { page: 1 });
  yield put(actSalesType.setGratuity(resGratuity.data));
  yield call(openRightColumn);
}

export function* createSalesTypeFlow(request) {
  const {
    payload: { data, previousSalesType },
  } = request;
  yield put(act.showProgressBar());
  yield put(actSalesType.isSubmittingForm(true));
  try {
    const response = yield call(apiSalesType.createSalesType, data);
    const salesTypeData = response.data;
    const salesType = [response.data];
    previousSalesType.forEach(sales => {
      salesType.push(sales);
    });
    yield put(
      actNotif.success(
        'Sales Type was successfully saved.',
        yield getCloneOutletNotification()
      )
    );
    clevertapLibrarySalesType.createSalesTypeOneOutletSuccess({
      salesTypeName: salesTypeData.name,
      gratuityAssign: salesTypeData.gratuities.length > 0 ? 'Yes' : 'No',
      numOfGratuity: salesTypeData.gratuity_applied_count,
      gratuityAssignNameList: salesTypeData.gratuities,
      outletIds: salesTypeData.outlet_id,
    });
    yield put(actSalesType.setListSalesType(salesType));
    yield put(actSalesType.setSalesTypeDetail(salesTypeData));
    const listIdGratuities = [];
    if (salesTypeData.gratuities.length > 0) {
      salesTypeData.gratuities.forEach(listId => {
        listIdGratuities.push(listId.id);
      });
    }
    salesTypeData.active_gratuities = listIdGratuities;
    yield call(fillFormSalesTypeDetail, {
      id: salesTypeData.id,
      name: salesTypeData.name,
      gratuity_applied_count: salesTypeData.gratuity_applied_count,
      outlet_id: salesTypeData.outlet_id,
      active_gratuities: salesTypeData.active_gratuities,
    });
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actSalesType.isSubmittingForm(false));
  }
}

export function* updateSalesTypeFlow(request) {
  const {
    payload: {
      idSalesType,
      currentSalesType,
      previousSalesType,
      initialSalesType,
      gratuity,
    },
  } = request;
  let salesTypeData;
  const mpNewGratuityAssignArray = [];
  const mpOldGratuityAssign = [];

  yield put(act.showProgressBar());
  yield put(actSalesType.isSubmittingForm(true));
  try {
    const response = yield call(
      apiSalesType.updateSalesType,
      idSalesType,
      currentSalesType
    );
    const listIdGratuities = [];
    if (response.data.gratuities.length > 0) {
      response.data.gratuities.forEach(gratuity => {
        listIdGratuities.push(gratuity.id);
        mpNewGratuityAssignArray.push(gratuity.name);
      });
    }
    if (initialSalesType.active_gratuities.length > 0) {
      initialSalesType.active_gratuities.forEach(gratuityId => {
        gratuity.results.forEach(allGratuity => {
          if (allGratuity.id === gratuityId) {
            mpOldGratuityAssign.push(allGratuity.name);
          }
        });
      });
    }
    const detailSalesType = {
      active_state: response.data.active_state,
      business_id: response.data.business_id,
      gratuity_applied_count: response.data.gratuity_applied_count,
      id: response.data.id,
      name: response.data.name,
      outlet_id: response.data.outlet_id,
      created_at: response.data.synchronized_at,
      updated_at: response.data.updated_at,
      active_gratuities: listIdGratuities,
      has_business_level_entity:
        response.data.has_business_level_entity || false,
    };
    salesTypeData = detailSalesType;
    const salesType = [];
    previousSalesType.forEach(sales => {
      if (sales.id === idSalesType) {
        salesType.push(salesTypeData);
      } else {
        salesType.push(sales);
      }
    });
    yield put(
      actNotif.success(
        'Sales Type was successfully saved.',
        yield getCloneOutletNotification()
      )
    );
    yield put(actSalesType.setListSalesType(salesType));
    yield put(actSalesType.setSalesTypeDetail(salesTypeData));
    clevertapLibrarySalesType.editSalesTypeSuccess({
      oldSalesTypeName: initialSalesType.name,
      oldGratuityAssign: mpOldGratuityAssign,
      newSalesTypeName: salesTypeData.name,
      newGratuityAssign: mpNewGratuityAssignArray,
      outletIds: salesTypeData.outlet_id,
    });
    yield call(fillFormSalesTypeDetail, {
      id: salesTypeData.id,
      name: salesTypeData.name,
      gratuity_applied_count: salesTypeData.gratuity_applied_count,
      outlet_id: salesTypeData.outlet_id,
      active_gratuities: salesTypeData.active_gratuities,
    });
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actSalesType.isSubmittingForm(false));
  }
}

export function* createSalesTypeAllOutletsFlow(request) {
  const {
    payload: { data, businessId, previousSalesType, outlets },
  } = request;
  const otherOutlets = [];
  if (outlets.length > 0) {
    outlets.forEach(outlet => {
      if (outlet.id !== data.outlet_id) {
        otherOutlets.push(outlet.id);
      }
    });
  }
  const bodyData = {
    name: data.name,
    business_id: businessId,
    outlet_id: data.outlet_id,
    active_gratuities: data.active_gratuities,
    other_outlets: otherOutlets,
  };
  yield put(act.showProgressBar());
  yield put(actSalesType.isSubmittingForm(true));
  try {
    const response = yield call(
      apiSalesType.createSalesTypeAllOutlets,
      bodyData
    );
    const listIdGratuities = [];
    if (response.data.gratuities.length > 0) {
      response.data.gratuities.forEach(listId => {
        listIdGratuities.push(listId.id);
      });
    }
    yield put(actSalesType.setFailedOutlets(response.data.error_messages));
    const currentSalesType = {
      active_gratuities: listIdGratuities,
      active_state: response.data.active_state,
      business_id: response.data.business_id,
      gratuity_applied_count: response.data.gratuity_applied_count,
      id: response.data.id,
      name: response.data.name,
      outlet_id: response.data.outlet_id,
      synchronized_at: response.data.synchronized_at,
      updated_at: response.data.updated_at,
    };
    const salesType = [currentSalesType];
    previousSalesType.forEach(sales => {
      salesType.push(sales);
    });
    yield put(actSalesType.setListSalesType(salesType));
    yield put(actSalesType.setSalesTypeDetail(currentSalesType));
    clevertapLibrarySalesType.createSalesTypeMultipleOutletsSuccess({
      salesTypeName: currentSalesType.name,
      gratuityAssign: response.data.gratuities.length > 0 ? 'Yes' : 'No',
      numOfGratuity: currentSalesType.gratuity_applied_count,
      gratuityAssignNameList: response.data.gratuities,
      outletIds: currentSalesType.outlet_id,
    });
    yield call(fillFormSalesTypeDetail, {
      id: currentSalesType.id,
      name: currentSalesType.name,
      gratuity_applied_count: currentSalesType.gratuity_applied_count,
      outlet_id: currentSalesType.outlet_id,
      active_gratuities: currentSalesType.active_gratuities,
    });
    yield put(actSalesType.showSaveToAllOutletsModal());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actSalesType.isSubmittingForm(false));
  }
}

export default function* saga() {
  yield takeLatest(LIBRARY_SALES_TYPE_PAGE_REQUEST, salesTypePageRequestFlow);
  yield takeEvery(LIBRARY_SALES_TYPE_LIST_REQUEST, salesTypeRequestFlow);
  yield takeLatest(LIBRARY_SALES_TYPE_ON_CLICK_ROW, onClickRowFlow);
  yield takeLatest(LIBRARY_SALES_TYPE_ON_CLICK_CANCEL, onClickCancelFlow);
  // deleted
  yield takeLatest(
    LIBRARY_SALES_TYPE_DELETE_SALES_REQUEST,
    deleteSalesTypeRequest
  );
  yield takeLatest(LIBRARY_SALES_TYPE_DELETE_SALES, deleteSalesTypeFlow);
  yield takeLatest(LIBRARY_SALES_TYPE_CANCEL_DELETE, cancelDeleteSalesTypeFlow);
  // activated
  yield takeLatest(
    LIBRARY_SALES_TYPE_ACTIVATED_SALES_REQUEST,
    activatedSalesTypeRequest
  );
  yield takeLatest(LIBRARY_SALES_TYPE_ACTIVATED_SALES, activatedSalesTypeFlow);
  yield takeLatest(
    LIBRARY_SALES_TYPE_CANCEL_ACTIVATED,
    cancelActivatedSalesTypeFlow
  );
  // outlets
  yield takeLatest(LIBRARY_SALES_TYPE_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);
  // create
  yield takeLatest(
    LIBRARY_SALES_TYPE_ON_CLICK_CREATE_SALES,
    onClickCreateSalesTypeFlow
  );
  yield takeLatest(LIBRARY_SALES_TYPE_SUBMIT_FORM_UPDATE, updateSalesTypeFlow);
  yield takeLatest(LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE, createSalesTypeFlow);
  yield takeLatest(
    LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE_ALL_OUTLETS,
    createSalesTypeAllOutletsFlow
  );
  yield takeLatest(
    LIBRARY_SALES_TYPE_RESERVED_FIND_BY_NAME,
    findSalesTypeReservedByNameFlow
  );
}
